<template>
  <div v-if="to" class="grid">
    <a v-if="isExternalLink" :href="to" target="_blank" class="grid">
      <slot />
    </a>
    <nuxt-link v-else :to="to" class="grid">
      <slot />
    </nuxt-link>
  </div>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: '_self'
    }
  },
  computed: {
    isExternalLink() {
      return this.target === '_blank';
    }
  }
};
</script>
<style lang="css" scoped>
.grid {
  display: grid;
}
</style>
